import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgDown(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46437 14.6716L11.6464 17.8536C11.8416 18.0488 12.1582 18.0488 12.3535 17.8536L15.5354 14.6716C15.7307 14.4763 15.7307 14.1597 15.5354 13.9645C15.3402 13.7692 15.0236 13.7692 14.8283 13.9645L12.4999 16.2929L12.4999 5.5C12.4999 5.22386 12.276 5 11.9999 5C11.7238 5 11.4999 5.22386 11.4999 5.5L11.4999 16.2929L9.17148 13.9645C8.97621 13.7692 8.65963 13.7692 8.46437 13.9645C8.26911 14.1597 8.26911 14.4763 8.46437 14.6716Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);

var DownSolid = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { DownSolid as default };
